import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Sidebar() {

    const location = useLocation()   // ✅ ADD
    const menus = JSON.parse(localStorage.getItem("userMenus")) || [];

    const buildMenuList = (list) => {
        const map = {};
        const roots = [];

        list.forEach(m => {
            map[m.id] = {
                menuName: m.menuName,
                url: m.menuUrl || "#",
                subMenu: [],
                menuIcon: m.menuIcon
            };
        });

        list.forEach(m => {
            if (m.parentId && map[m.parentId]) {
                map[m.parentId].subMenu.push(map[m.id]);
            } else {
                roots.push(map[m.id]);
            }
        });

        return roots;
    };


    // const [menuList] = useState([
    //     {
    //         menuName: "All Projects",
    //         url: "/allproject/",
    //         subMenu: []
    //     },
    //     {
    //         menuName: "Master",
    //         url: "#",
    //         subMenu: [
    //             { menuName: "Payment Master", url: "/paymentmaster/", icon: "bi bi-building" },
    //             { menuName: "Expense Master", url: "/expensemaster/", icon: "bi bi-building" },
    //         ],
    //     },
    //     {
    //         menuName: "Investor",
    //         url: "/investorlist/",
    //         subMenu: [
    //             { menuName: "Company", url: "/showcompanyinvestor/", icon: "bi bi-building" },
    //             { menuName: "Individual", url: "/individualinvestor/", icon: "bi bi-building" },
    //         ],
    //     },
    //     {
    //         menuName: "Vendor",
    //         url: "/vendorlist/",
    //         subMenu: [
    //             { menuName: "Company", url: "/showcompanyvendor/", icon: "bi bi-building" },
    //             { menuName: "Individual", url: "/individualvendor/", icon: "bi bi-building" },
    //         ],
    //     },
    //     {
    //         menuName: "Account",
    //         url: "",
    //         subMenu: [
    //             { menuName: "Expenses Overview", url: "/expensesoverview/", icon: "bi bi-building" },
    //             { menuName: "Investor Portfolio Overview", url: "/investorportfolio/", icon: "bi bi-building" },
    //             { menuName: "Owner Portfolio Overview", url: "/ownerportfolio/", icon: "bi bi-building" },
    //             {
    //                 menuName: "Investor Portfolio Overview New",
    //                 url: "/InvestorPortfolioNew/",
    //                 icon: "bi bi-building",
    //             },
    //         ],
    //     },
    //     {
    //         menuName: "Project Portfolio",
    //         url: "/projectportfolio/",
    //         subMenu: [],
    //     },
    //     {
    //         menuName: "Vendor Management",
    //         url: "/overview",
    //         subMenu: [
    //             { menuName: "Vendor Overview", url: "/vendoroverview/overview", icon: "bi bi-eye" },
    //             { menuName: "Work Order", url: "/workorder", icon: "bi bi-file-earmark" },
    //             { menuName: "Purchase Order", url: "/purchaseorder", icon: "bi bi-cart" },
    //         ],
    //     },
    // ])
    const menuList = buildMenuList(menus);

    const [activeIndex, setActiveIndex] = useState(null)

    const handleNavbar = (e, index, close = true) => {
        e.preventDefault(); // Prevent default behavior

        if (activeIndex === index && close) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    }

    return (
        <aside id="sidebar" className="sidebar">
            <ul className="sidebar-nav">

                {menuList.map((val, ind) => {

                    /* 🔹 NO SUBMENU */
                    if (val.subMenu.length === 0) {
                        return (
                            <li className="nav-item" key={ind}>
                                <Link
                                    to={val.url}
                                    className={`nav-link ${location.pathname.startsWith(val.url) ? "selected" : ""
                                        }`}
                                >
                                    <i className={val.menuIcon}></i>
                                    <span>{val.menuName}</span>
                                </Link>
                            </li>
                        )
                    }

                    /* 🔹 WITH SUBMENU */
                    return (
                        <li className="nav-item" key={ind}>
                            <Link
                                to={val.url}
                                className={`nav-link ${activeIndex === ind ? "collapse selected" : "collapsed"
                                    }`}
                                onClick={(e) => handleNavbar(e, ind)}
                            >
                                <i className={val.menuIcon}></i>
                                <span>{val.menuName}</span>
                                <i className="bi bi-chevron-down ms-auto"></i>
                            </Link>

                            <ul
                                className={`nav-content collapse ${activeIndex === ind ? "show d-block" : "d-none"
                                    }`}
                            >
                                {val.subMenu.map((vv, i) => (
                                    <li
                                        key={i}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            handleNavbar(e, ind, false)
                                        }}
                                    >
                                        <Link
                                            to={vv.url}
                                            className={
                                                location.pathname.startsWith(vv.url) ||
                                                    (vv.url === "/vendoroverview/overview" &&
                                                        location.pathname.startsWith("/vendoroverview/vendordetail"))
                                                    ? "active-submenu"
                                                    : ""
                                            }
                                        >
                                            <i className={vv.menuIcon}></i>
                                            <span>{vv.menuName}</span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    )
                })}

            </ul>
        </aside>
    )
}
